<template>
  <el-card class="box-card mb-50 detail-screen detail-notice-screen">
    <div class="group-input"></div>
    <div class="notice">
      <div class="header">
        <span>{{ formatDate(notice.created_at) }}</span>
        <span class="ml-20" v-if="notice.category_name">{{ notice.category_name }}</span>
      </div>
      <el-row>
        <el-col>
          <span class="title">{{ notice.title }}</span>
        </el-col>
      </el-row>
      <hr/>
      <div class="content">
        <el-row>
          <el-col :span="24" v-html="notice.content_formated" class="main"></el-col>
          <el-col :span="24" class="text-center" v-if="notice.image_url">
            <img class="image" :src="notice.image_url">
          </el-col>
        </el-row>
      </div>
    </div>
    <el-row>
      <el-col :span="24" class="text-center mt-36">
        <el-button type="primary" @click="redirectEdit" class="btn btn-create btn-w157" v-if="site != $siteType.site_partner">{{ $t('notices.btn_update_notice') }}</el-button>
        <el-button type="primary" @click="confirmDelete" class="btn btn-edit btn-w157" v-if="site != $siteType.site_partner">{{ $t('notices.btn_delete') }}</el-button>
        <el-button @click="back" class="btn btn-back btn-w157" v-if="site === $siteType.site_partner">{{ $t('notices.btn_back_list_notice') }}</el-button>
      </el-col>
    </el-row>
    <dialog-delete-notice
      v-if="isOpenPopup" :openPopup="true"
      :notice="this.notice"
      @is-close-popup="handleClosePopup"
      :url="urls.delete"
    >
    </dialog-delete-notice>
  </el-card>
</template>
<script>
  export default {
    props: {
      notice: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      site: { type: Number, required: false },
    },
    data() {
      return {
        isOpenPopup: false
      }
    },
    methods: {
      formatDate(dateTime) {
        return dateTime ? this.$dayjs(dateTime).format('YY.MM.DD') : '';
      },

      redirectEdit() {
        window.location.href = this.urls.edit;
      },

      handleClosePopup() {
        this.isOpenPopup = false;
      },

      confirmDelete() {
        this.isOpenPopup = true;
      },

      back() {
        window.location.href = this.urls.index;
      }
    },
  }
</script>
<style lang="scss" scoped>
  .group-input {
    height: 25px;
  }
  .notice {
    margin-top: 20px;
    .header {
      font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
      letter-spacing: 1.8px;
      color: #7B7B7B;
    }
    .title {
      height: 30px;
      align-content: center;
      padding-bottom: 0;
      p {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #000000;
        font-weight: bold;
      }
    }
    .content {
      font: normal normal normal 13px/30px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
      padding-bottom: 0;
      text-align: justify;
    }
    .image {
      width: 800px;
      height: 600px;
      margin-top: 20px;
    }
    hr {
      color: #000000;
      opacity: 1;
    }
  }
  .el-row {
    .mt-36 {
      margin-top: 36px;
    }
  }
</style>
